/*=========================================================================================
  File Name: state.js
  Description: Cart State
  ----------------------------------------------------------------------------------------
  Item Name: Fujisushi Web app
  Author: Tan Tran
==========================================================================================*/

export default {
    selectedItems: [],
    estimatedTime : 0,
    amount : 0.0,
    pickupTime : null,
    discountCode : null,
    orderInfo : {
      customerName : '',
      email : '',
      phoneNumber : '',
      comment : '',
      waitingTime : null,
      pickupTime : null, 
      asap : false

    }
}